module.exports = {"371481001":"市中街道","371481002":"胡家街道","371481003":"云红街道","371481004":"郭家街道","371481100":"杨安镇","371481101":"朱集镇","371481102":"黄夹镇","371481103":"丁坞镇","371481104":"花园镇","371481105":"郑店镇","371481106":"化楼镇","371481107":"孔镇","371481108":"铁营镇","371481200":"西段乡","371481201":"大孙乡","371481203":"寨头堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371481.json
// module id = 1362
// module chunks = 0